import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import HelperWidget from "@/components/Helper/HelperWidget";
import { useActiveTenant } from "@/components/tenant/TenantSelector";

export function MainLayout() {
  const [tenantId] = useActiveTenant();
  // Pass slug if we can resolve it; otherwise the helper just runs
  // without the tenant_slug context — backend tolerates absence.
  return (
    <div className="flex h-screen overflow-hidden bg-gray-950">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <HelperWidget tenantSlug={tenantId ? String(tenantId) : undefined} />
    </div>
  );
}
